import { Service } from '@/types'; // Import the Service type

export function defaultValues(service?: Service) {
  return {
    id: service?.id || '',
    name: service?.name || '',
    subTitle: service?.subTitle || '',
    description: service?.description || '',
    image: service?.image || '',
    icon: service?.icon || '',
    createdDate: service?.createdDate || new Date().toISOString(),
    createdUser: service?.createdUser || '',
  } as Service;
}
